import { Button } from '@mui/material';
import { Dispatch } from 'react';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRegisterUnregisteredUserButton } from '../hooks/useRegisterUnregisteredUserButton';
import { FormValues } from './BulkCreateEmailModal';

type RegisterUnregisteredUserButtonProps = {
  errorMessage: string;
  setErrorMessage: Dispatch<string>;
  setIsLoading: Dispatch<boolean>;
  setValue: UseFormSetValue<FormValues>;
  getValues: UseFormGetValues<FormValues>;
};

export const RegisterUnregisteredUserButton = ({
  errorMessage,
  setErrorMessage,
  setIsLoading,
  setValue,
  getValues,
}: RegisterUnregisteredUserButtonProps) => {
  const { t } = useTranslation();
  const { id: respondentRequestId } = useParams();

  const { handleOnClick, errorEmails } = useRegisterUnregisteredUserButton({
    respondentRequestId,
    errorMessage,
    setErrorMessage,
    setIsLoading,
    setValue,
    getValues,
  });

  if (errorEmails.length === 0 || !respondentRequestId) {
    return null;
  }

  return (
    <Button variant={'contained'} onClick={handleOnClick} sx={{ ml: 2 }}>
      {t(`enqueteCreate.bulkCreateEmailModal.button.RegisterUnregisteredUser.content`)}
    </Button>
  );
};
